/* eslint-disable sonarjs/no-angular-bypass-sanitization */
import { Pipe, PipeTransform, inject } from '@angular/core';
import { SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeCMSContent' })
export class SafeCMSContentPipe implements PipeTransform {
  protected sanitizer = inject(DomSanitizer);

  transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    if (value && /<[a-z][\s\S]*>/.test(value)) {
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`Invalid safe type specified: ${type}`);
      }
    } else {
      return value;
    }
  }
}
